<div
    ngfDrop
    selectable="1"
    multiple="1"
    [(files)]="dndFiles"
    [(validDrag)]="validDrag"
    (filesChange)="changedFile()"
    [accept]="allowedFileTypes"
    [class.drag]="validDrag"
    class="drop-zone"
>
    {{ 'shared.miscellaneous.drop' | translate }}
</div>
@if (dndFiles?.length > 0) {
    <div class="col-12 pending-documents">
        <div class="options-form options-form--header">
            <div class="row mb-2">
                <div class="col-12">
                    <p>{{ 'shared.miscellaneous.new-documents' | translate }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 pending-documents-table">
                <mat-table [dataSource]="newDocDataSource">
                    <ng-container matColumnDef="select">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-checkbox
                                (change)="changeDeleteStatus(element, $event.checked)"
                                [checked]="selectedFiles.has(element)"
                            ></mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef>
                            {{ 'shared.miscellaneous.name' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{ element.name }}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="delete">
                        <mat-header-cell *matHeaderCellDef>
                            <i class="material-icons">delete</i>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element; let i = index">
                            <button type="button">
                                <i (click)="cancelNewDocument(i, 1)" class="icon a-icon a-icon--delete"></i>
                            </button>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumnsDataNew"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumnsDataNew"></mat-row>
                </mat-table>
            </div>
        </div>
        <div class="pending-document-actions d-flex align-items-center justify-content-between gap-2">
            <div class="pending-document-warning">
                @if (showWarningArchive) {
                    {{ 'shared.miscellaneous.file-exists-archive' | translate }}
                }
                @if (showWarningDelete) {
                    {{ 'shared.miscellaneous.file-exists-delete' | translate }}
                }
            </div>
            <div class="d-flex gap-2">
                <ceres-button [style]="'red'" [disabled]="selectedFiles.size < 1" (click)="deleteSelected()">
                    {{ 'shared.buttons.delete' | translate }}
                </ceres-button>
                <ceres-button [disabled]="uploading" (click)="uploadRequested.emit()">
                    {{ 'shared.buttons.upload' | translate }}
                </ceres-button>
            </div>
        </div>
    </div>
}
